import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import api from "../../services/api";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Box,
  Heading,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
  Flex,
  Button,
  useToast,
  Link,
  FormControl,
  FormLabel,
  Input,
  Select,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Tooltip,
} from "@chakra-ui/react";
import Navbar from "../../Components/Navbar";
import { RedactionContext } from "../../contexts/Redacoes";
import AdicionarSimuladoModal from "../../Components/AddSimulado";
import AdicionarRedacaoModal from "../../Components/AddRedacao";
import MeuEditor from "../../Components/Editor/CKeditor";
import MeuTinyEditor from "../../Components/Editor/editor";

const Redacoes = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const roleId = user?.role_id;
  const toast = useToast();
  const { getRedactionInfoApi, getRedactionTemasApi, deleteSimuladoApi } =
    useContext(RedactionContext);

  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [redactionInfo, setRedationInfo] = useState("");
  const [redactions, setRedactions] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const deleteDisclosure = useDisclosure();
  const cancelRef = useRef(null);
  const [deleteId, setDeleteId] = useState();
  const [isDeleting, setIsDeleting] = useState(false);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedRedaction, setSelectedRedaction] = useState(null);

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = deleteDisclosure;

  async function getRedactionInfo() {
    try {
      const response = await getRedactionInfoApi();
      setRedationInfo(response.data[0]);
      getRedactionTemas();
    } catch (error) {}
  }

  async function getRedactionTemas() {
    try {
      const response = await getRedactionTemasApi();

      setRedactions(response.data[0]);

      console.log(response.data[0]);
    } catch (error) {}
  }

  const handleUpdateFile = async (e) => {
    e.preventDefault();

    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    setIsUploading(true);
    try {
      const response = await api.post(`redaction/info/update-file`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast({
        title: "Arquivo atualizado com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      getRedactionInfo();
    } catch (error) {
      toast({
        title: "Erro ao atualizar assunto",
        status: "error",
        isClosable: true,
      });
    } finally {
      setIsUploading(false);
    }
  };
  const openModal = (redaction) => {
    setSelectedRedaction(redaction);
    setIsOpenModal(true);
  };

  const closeModal = () => {
    setIsOpenModal(false);
    setSelectedRedaction(null);
  };

  const handleUpdate = async () => {
    if (!selectedRedaction) return;

    setIsSubmitting(true);
    try {
      await api.put(`/redaction/tema/${selectedRedaction.id}`, {
        title: selectedRedaction.theme_redacao,
        description: selectedRedaction.info,
        difficulty: selectedRedaction.difficulty,
      });

      toast({
        title: "Redação atualizada com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      getRedactionInfo();
      closeModal();
    } catch (error) {
      toast({
        title: "Erro ao atualizar redação.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenDelete = (id) => {
    setDeleteId(id);
    onDeleteOpen();
  };

  // faz a chamada DELETE
  const handleConfirmDelete = async () => {
    if (deleteId === null) return;
    setIsDeleting(true);
    try {
      await api.delete(`delete/redaction/tema/${deleteId}`);
      toast({
        title: "Redação deletada com sucesso!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      getRedactionInfo(); // recarrega a lista
    } catch (err) {
      toast({
        title: "Erro ao deletar redação.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsDeleting(false);
      onDeleteClose();
      setDeleteId(null);
    }
  };

  useEffect(() => {
    getRedactionInfo();
  }, []);

  return (
    <>
      <Navbar />

      <Box p={8} ml={{ base: 0, md: 60 }}>
        <Flex justifyContent={"space-between"}>
          <Box>
            <Heading as="h1" size="xl" mb={4}>
              Lista de Redações
            </Heading>

            <Text mb={2}>Arquivo de informações das redações:</Text>

            {redactionInfo?.file_path && (
              <Link
                href={`https://api.colegionaval.com.br/storage/app/public/${redactionInfo.file_path}`}
                isExternal
                color="blue.500"
                mb={4}
                display="block"
              >
                Ver arquivo de informações gerais sobre a redação
              </Link>
            )}
            {roleId === 1 && (
              <>
                <Box>
                  <form onSubmit={handleUpdateFile}>
                    <FormLabel>Atualizar arquivo:</FormLabel>
                    <FormControl mb={4} display={"flex"} alignItems={"center"}>
                      <Input
                        type="file"
                        accept=".pdf,.doc,.docx,.jpg,.png"
                        onChange={(e) => setFile(e.target.files[0])}
                      />
                      <Button
                        ml={4}
                        width={"200px"}
                        type="submit"
                        colorScheme="blue"
                        isLoading={isUploading}
                      >
                        Atualizar Arquivo
                      </Button>
                    </FormControl>
                  </form>
                </Box>
              </>
            )}
          </Box>

          <Button colorScheme="teal" mb={4} onClick={onOpen}>
            Adicionar Redação
          </Button>
          <AdicionarRedacaoModal
            isOpen={isOpen}
            onClose={onClose}
            onSuccess={getRedactionInfo}
          />
        </Flex>
        <Table variant="striped">
          <Thead>
            <Tr>
              <Th>Título da redação</Th>
              <Th>Descrição</Th>
              {/* <Th>Dificuldade</Th> */}
              <Th>Ações</Th>
            </Tr>
          </Thead>
          <Tbody>
            {redactions?.map((redaction) => (
              <>
                <Tr key={redaction.id}>
                  <Td>{redaction.theme_redacao}</Td>
                  <Td>
                    {(() => {
                      const full = redaction.info;
                      const isLong = full.length > 30;
                      const display = isLong ? `${full.slice(0, 30)}…` : full;
                      return (
                        <Tooltip label={full} isDisabled={!isLong}>
                          <Text
                            whiteSpace="nowrap"
                            overflow="hidden"
                            textOverflow="ellipsis"
                          >
                            {display}
                          </Text>
                        </Tooltip>
                      );
                    })()}
                  </Td>
                  {/* <Td>
                    {" "}
                    {
                      redaction.difficulty === 1
                        ? "Iniciante"
                        : redaction.difficulty === 2
                        ? "Intermediário"
                        : redaction.difficulty === 3
                        ? "Avançado"
                        : "Desconhecido" // Caso o valor de difficulty não seja 1, 2 ou 3
                    }
                  </Td> */}
                  <Td>
                    <Button
                      colorScheme="teal"
                      onClick={() => openModal(redaction)}
                    >
                      Editar Redação
                    </Button>
                    <Button
                      ml={5}
                      colorScheme="red"
                      onClick={() => {
                        setDeleteId(redaction.id);
                        deleteDisclosure.onOpen();
                      }}
                    >
                      Excluir
                    </Button>
                  </Td>
                </Tr>
              </>
            ))}
          </Tbody>
        </Table>

        {/* AlertDialog de confirmação */}
        <AlertDialog
          isOpen={isDeleteOpen}
          leastDestructiveRef={cancelRef}
          onClose={onDeleteClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Confirmar Exclusão
              </AlertDialogHeader>

              <AlertDialogBody>
                Tem certeza que deseja deletar esta redação? Essa ação não pode
                ser desfeita.
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onDeleteClose}>
                  Cancelar
                </Button>
                <Button
                  colorScheme="red"
                  onClick={handleConfirmDelete}
                  ml={3}
                  isLoading={isDeleting}
                >
                  Excluir
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Box>

      {isOpenModal && (
        <Modal isOpen={isOpenModal} onClose={closeModal} size="4xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Editar Redação</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl>
                <FormLabel>Título</FormLabel>
                <Input
                  value={selectedRedaction.theme_redacao}
                  onChange={(e) =>
                    setSelectedRedaction({
                      ...selectedRedaction,
                      theme_redacao: e.target.value,
                    })
                  }
                />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>Descrição</FormLabel>
                <MeuTinyEditor
                  value={selectedRedaction.info ?? " "}
                  onChange={(e) =>
                    setSelectedRedaction({
                      ...selectedRedaction,
                      info: e,
                    })
                  }
                />
              </FormControl>

              {/* <FormControl mt={4}>
                <FormLabel>Dificuldade</FormLabel>
                <Select
                  value={selectedRedaction.difficulty}
                  onChange={(e) =>
                    setSelectedRedaction({
                      ...selectedRedaction,
                      difficulty: Number(e.target.value),
                    })
                  }
                >
                  <option value={1}>Iniciante</option>
                  <option value={2}>Intermediário</option>
                  <option value={3}>Avançado</option>
                </Select>
              </FormControl> */}
            </ModalBody>

            <ModalFooter>
              <Button onClick={handleUpdate}>Atualizar</Button>
              <Button ml={3} onClick={closeModal}>
                Cancelar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default Redacoes;
